// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__IOdDz","errorLogs":"styles_errorLogs__15YEX"};